<template>
    <div class="wrapper">
      <b-row>
        <b-col>
          <b-card header="Requested slugs">
            <div class="filter-bar ui basic segment grid">
                <div class="ui form">
                    <div class="inline field">
                        <label>Search for:</label>
                        <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="Slug">
                        <button class="ui primary button" @click="doFilter">Go</button>
                        <button class="ui button" @click="resetFilter">Reset</button>
                        <a v-if="permission > 1" :href="slugUrl" target="_blank"><button class="ui button">Banner Slugs</button></a>
                    </div>
                </div>
            </div>
            <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions" >
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <!-- <button class="btn btn-info" @click="resetSlug(props.rowData._id)"><i class="fa fa-edit"></i>Reset</button>&nbsp;&nbsp; -->
                  <button class="btn btn-danger" @click="deleteSlug(props.rowData._id)"><i class="fa fa-remove"></i>Delete</button>&nbsp;&nbsp;
                  <button class="btn btn-info" @click="passCheck(props.rowData._id ,props.rowData.slug)"><i class="fa fa-remove"></i>Recheck Status</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
                <vuetable-pagination-info ref="paginationInfo"
                ></vuetable-pagination-info>
                <vuetable-pagination ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
</template>

<script>

import Vue from 'vue'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import { mapGetters } from 'vuex'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      slugUrl: '',
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      names: [],
      name: '',
      moreParams: {},
      filterText: '',

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'slug',
          title: 'Banner Slug',
          sortField: 'slug',
          callback: 'formatSlug'
        },
        {
          name: 'requests_per_referrer',
          title: 'Referrers',
          callback: 'formatReferrers'

        },
        {
          name: 'created_at',
          title: 'First request',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: 'updated_at',
          title: 'Last request',
          sortField: 'updated_at',
          callback: 'formatDate'
        },
        {
          name: 'requests',
          title: 'Requests',
          sortField: 'requests'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          callback: 'formatStatus'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatStatus (value) {
      return value === 404 ? `<strong><span class="text-danger">${value}</span></strong>` : `${value}`
    },
    formatSlug (value) {
      const val = value.replace(this.apiKey, ':apiKey')
      return `<strong><a href="${process.env.VUE_APP_PRODUCTION_URL + value}" target="_blank">${val}</a></strong>`
    },
    formatReferrers (value) {
      let referrers = '<ul style="list-style-type: none">'
      for (const [key, val] of Object.entries(value)) {
        referrers += '<li>'
        referrers += `<strong>${this.decodeKey(key)}</strong> : ${val}`
        referrers += '</li>'
      }
      referrers += '</ul>'
      return referrers
    },
    passCheck (id, slug) {
      this.$http.get(`${process.env.VUE_APP_PRODUCTION_URL}${slug}`).then((result) => {
        // status 200, update record
        this.$http.post(`${this.$api_url}/slugs/passCheck`, { id: id, status: result.status }).then(result => {
          this.$refs.vuetable.refresh()
          alert('Slug status updated!')
        })
      }).catch(error => {
        // status 404, update record
        this.$http.post(`${this.$api_url}/slugs/passCheck`, { id: id, status: error.response.status }).then(result => {
          this.$refs.vuetable.refresh()
          alert('Slug status updated!')
        })
        // await BannerSlug.where('_id', id ).update({ status: error.status })
      })
    },
    decodeKey (key) {
      return key.replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u0024', '$').replace('\\\\', '\\')
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteSlug (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/slugs/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Referrer deleted!')
        })
      } else {
        alert('Referrer not deleted!')
      }
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetSlug (id) {
      if (confirm('Are you sure?')) {
        this.$http.patch(`${this.$api_url}/slugs/edit/${id}`).then((success) => {
          this.reloadTable()
        })
      } else {
        alert('Slug not resetted!')
      }
    }
  },
  computed: {
    ...mapGetters(['apiKey', 'permission'])
  },
  created () {
    this.api_url = this.$api_url + '/slugs'
    this.slugUrl = `${this.$api_url}/banner/verifySlugs/${this.apiKey}`
  }
}
</script>
<style scoped>
</style>
